export { default } from './monthly-statements';
